export const settings_role_team_en = {
  settings_team_title: "Team",
  settings_team_desc:
    "Teams allows users to collaborate efficiently by sharing valuable resources and information within a team. This ensures that all team members have access to the tools and data they need to succeed.",
  settings_role_title: "Role",
  settings_role_desc:
    "Roles provide a powerful set of controls to manage access levels within the platform, ensuring that each team member has the appropriate permissions to perform their actions.",
  team_name: "Team name",
  role_name: "Role name",
  settings_team_sharing_rules_title: "Sharing Rules",
  settings_team_sharing_rules_desc:
    "Control how information is shared across teams, roles, or users. Set rules to automatically grant access to specific data or actions based on conditions you define.",

  assign_user_to_role_title: "Assign User(s) to Role",
  assign_user_to_role_role: "Roles",
  assign_user_to_role_roles_selected: "{0} user(s) selected",
  assign_user_to_team_title: "Assign User(s) to Team",
  assign_user_to_team_team: "Team",
  assign_user_to_team_sharing_rules: "Sharing rule group",
  assign_user_to_team_button: "Assign to Team",
  assign_user_to_role_button: "Assign to Role",

  remove_from_canvas: "Remove from canvas",
  teams_no_members_added: "No members have been added",
  list: "List",
  Permission: "Permission",
  Users: "Users",

  sharing_rules_new: "New",

  settings_team_canvas_tip:
    "Double-click a node to open the side panel settings",

  edit_user_access: "Edit user access",

  settings_sharing_rule_column_name: "User Sharing Rule",

  modify_sharing_rule: "Modify Sharing Rule",
};

export const settings_role_team_zhHans = {
  settings_team_title: "团队",
  settings_team_desc:
    "团队功能允许用户在团队中共享有价值的资源和信息，从而高效协作。这确保了所有团队成员都能访问成功所需的工具和数据。",
  settings_role_title: "角色",
  settings_role_desc:
    "角色提供了一套强大的权限控制功能，可管理平台内的访问级别，确保每位团队成员拥有执行其操作所需的适当权限。",
  team_name: "团队名称",
  role_name: "角色名称",
  settings_team_sharing_rules_title: "共享规则",
  settings_team_sharing_rules_desc:
    "控制信息在团队、角色或用户之间的共享方式。您可以设置规则，根据定义的条件自动授予对特定数据或操作的访问权限。",

  assign_user_to_role_title: "分配用户到角色",
  assign_user_to_role_role: "角色",
  assign_user_to_role_roles_selected: "已选择 {0} 个用户",
  assign_user_to_team_title: "分配用户到团队",
  assign_user_to_team_team: "团队",
  assign_user_to_team_sharing_rules: "共享规则组",
  assign_user_to_team_button: "分配到团队",
  assign_user_to_role_button: "分配到角色",

  remove_from_canvas: "从画布中移除",
  teams_no_members_added: "尚未添加成员",
  list: "列表",
  Permission: "權限",
  Users: "使用者",
  sharing_rules_new: "新增",

  settings_team_canvas_tip: "双击节点以打开侧边栏设置",
  edit_user_access: "编辑用户访问权限",
  settings_sharing_rule_column_name: "用户共享规则",
  modify_sharing_rule: "修改共享规则",
};

export const settings_role_team_zhHant = {
  settings_team_title: "團隊",
  settings_team_desc:
    "團隊功能讓使用者能夠在團隊內共享寶貴的資源與資訊，提升協作效率。這可確保所有團隊成員都能存取達成成功所需的工具與資料。",
  settings_role_title: "角色",
  settings_role_desc:
    "角色提供一套強大的權限管理功能，用於控制平台內的存取層級，確保每位團隊成員擁有執行其操作所需的適當權限。",
  team_name: "團隊名稱",
  role_name: "角色名稱",
  settings_team_sharing_rules_title: "共用規則",
  settings_team_sharing_rules_desc:
    "控制資訊如何在團隊、角色或使用者之間共享。您可設定規則，根據自訂條件自動授予對特定資料或操作的存取權限。",

  assign_user_to_role_title: "指派使用者至角色",
  assign_user_to_role_role: "角色",
  assign_user_to_role_roles_selected: "已選擇 {0} 位使用者",
  assign_user_to_team_title: "指派使用者至團隊",
  assign_user_to_team_team: "團隊",
  assign_user_to_team_sharing_rules: "共享規則群組",
  assign_user_to_team_button: "指派至團隊",
  assign_user_to_role_button: "指派至角色",

  remove_from_canvas: "從畫布中移除",
  teams_no_members_added: "尚未新增成員",
  list: "清單",
  Permission: "权限",
  Users: "用户",
  sharing_rules_new: "新增",
  settings_team_canvas_tip: "雙擊節點以打開側邊欄設定",
  edit_user_access: "編輯使用者存取權限",
  settings_sharing_rule_column_name: "使用者共用規則",
  modify_sharing_rule: "修改共用規則",
};

export const settings_role_team_japanese = {
  settings_team_title: "チーム",
  settings_team_desc:
    "チーム機能により、ユーザーはチーム内で貴重なリソースと情報を共有し、コラボレーション効率を向上させることができます。これにより、すべてのチームメンバーが成功に必要なツールとデータにアクセスできます。",
  settings_role_title: "ロール",
  settings_role_desc:
    "ロールは、プラットフォーム内のアクセスレベルを制御する強力な権限管理機能を提供し、各チームメンバーが操作を実行するために適切な権限を持っていることを保証します。",
  team_name: "チーム名",
  role_name: "ロール名",
  settings_team_sharing_rules_title: "共有ルール",
  settings_team_sharing_rules_desc:
    "チーム、ロール、またはユーザー間で情報を共有する方法を制御します。カスタム条件に基づいて特定のデータや操作へのアクセス権を自動的に付与するルールを設定できます。",

  assign_user_to_role_title: "ユーザーをロールに割り当て",
  assign_user_to_role_role: "ロール",
  assign_user_to_role_roles_selected: "{0} ユーザーが選択されました",
  assign_user_to_team_title: "ユーザーをチームに割り当て",
  assign_user_to_team_team: "チーム",
  assign_user_to_team_sharing_rules: "共有ルールグループ",
  assign_user_to_team_button: "チームに割り当て",
  assign_user_to_role_button: "ロールに割り当て",

  remove_from_canvas: "キャンバスから削除",
  teams_no_members_added: "メンバーが追加されていません",
  list: "リスト",
  Permission: "権限",
  Users: "ユーザー",
  sharing_rules_new: "新規作成",
  settings_team_canvas_tip:
    "ノードをダブルクリックしてサイドバー設定を開きます",
  edit_user_access: "ユーザーアクセス権限を編集",
  settings_sharing_rule_column_name: "ユーザー共有ルール",
  modify_sharing_rule: "共有ルールを変更",
};

export const settings_role_team_korean = {
  settings_team_title: "팀",
  settings_team_desc:
    "팀 기능을 통해 사용자는 팀 내에서 귀중한 리소스와 정보를 공유하여 협업 효율성을 높일 수 있습니다. 이렇게 하면 모든 팀 구성원이 성공에 필요한 도구와 데이터에 액세스할 수 있습니다.",
  settings_role_title: "역할",
  settings_role_desc:
    "역할은 플랫폼 내 액세스 수준을 제어하는 강력한 권한 관리 기능을 제공하여 각 팀 구성원이 작업을 수행하는 데 필요한 적절한 권한을 갖도록 합니다.",
  team_name: "팀 이름",
  role_name: "역할 이름",
  settings_team_sharing_rules_title: "공유 규칙",
  settings_team_sharing_rules_desc:
    "팀, 역할 또는 사용자 간에 정보가 공유되는 방식을 제어합니다. 사용자 정의 조건에 따라 특정 데이터 또는 작업에 대한 액세스 권한을 자동으로 부여하는 규칙을 설정할 수 있습니다.",

  assign_user_to_role_title: "사용자를 역할에 할당",
  assign_user_to_role_role: "역할",
  assign_user_to_role_roles_selected: "{0} 사용자가 선택됨",
  assign_user_to_team_title: "사용자를 팀에 할당",
  assign_user_to_team_team: "팀",
  assign_user_to_team_sharing_rules: "공유 규칙 그룹",
  assign_user_to_team_button: "팀에 할당",
  assign_user_to_role_button: "역할에 할당",

  remove_from_canvas: "캔버스에서 제거",
  teams_no_members_added: "멤버가 추가되지 않았습니다",
  list: "목록",
  Permission: "권한",
  Users: "사용자",
  sharing_rules_new: "새로 만들기",
  settings_team_canvas_tip: "노드를 더블클릭하여 사이드바 설정 열기",
  edit_user_access: "사용자 액세스 편집",
  settings_sharing_rule_column_name: "사용자 공유 규칙",
  modify_sharing_rule: "공유 규칙 수정",
};
export const settings_role_team_hindi = {
  settings_team_title: "टीम",
  settings_team_desc:
    "टीम सुविधा उपयोगकर्ताओं को टीम के भीतर मूल्यवान संसाधनों और जानकारी को साझा करने में सक्षम बनाती है, जिससे सहयोग दक्षता बढ़ती है। यह सुनिश्चित करता है कि सभी टीम सदस्यों को सफलता के लिए आवश्यक उपकरण और डेटा तक पहुंच हो।",
  settings_role_title: "भूमिकाएँ",
  settings_role_desc:
    "भूमिकाएँ प्लेटफॉर्म के भीतर पहुंच स्तर को नियंत्रित करने के लिए एक शक्तिशाली अनुमति प्रबंधन सुविधा प्रदान करती हैं, यह सुनिश्चित करते हुए कि प्रत्येक टीम सदस्य के पास अपने कार्यों को निष्पादित करने के लिए उचित अनुमतियाँ हैं।",
  team_name: "टीम नाम",
  role_name: "भूमिका नाम",
  settings_team_sharing_rules_title: "साझाकरण नियम",
  settings_team_sharing_rules_desc:
    "नियंत्रित करें कि जानकारी टीमों, भूमिकाओं या उपयोगकर्ताओं के बीच कैसे साझा की जाती है। आप कस्टम शर्तों के आधार पर विशिष्ट डेटा या कार्यों तक पहुंच स्वचालित रूप से प्रदान करने के लिए नियम सेट कर सकते हैं।",

  assign_user_to_role_title: "उपयोगकर्ता को भूमिका असाइन करें",
  assign_user_to_role_role: "भूमिका",
  assign_user_to_role_roles_selected: "{0} उपयोगकर्ता चयनित",
  assign_user_to_team_title: "उपयोगकर्ता को टीम असाइन करें",
  assign_user_to_team_team: "टीम",
  assign_user_to_team_sharing_rules: "साझाकरण नियम समूह",
  assign_user_to_team_button: "टीम को असाइन करें",
  assign_user_to_role_button: "भूमिका असाइन करें",

  remove_from_canvas: "कैनवास से हटाएं",
  teams_no_members_added: "कोई सदस्य जोड़ा नहीं गया",
  list: "सूची",
  Permission: "अनुमति",
  Users: "उपयोगकर्ता",
  sharing_rules_new: "नया बनाएं",
  settings_team_canvas_tip: "साइडबार सेटिंग खोलने के लिए नोड पर डबल-क्लिक करें",
  edit_user_access: "उपयोगकर्ता एक्सेस संपादित करें",
  settings_sharing_rule_column_name: "उपयोगकर्ता शेयरिंग नियम",
  modify_sharing_rule: "शेयरिंग नियम संशोधित करें",
};
